type SEOAgentBridgeViewedPayload = {
  source_path: string;
  intent: string;
  page_category: string;
  offer_type: string;
  plan_id?: string;
  placement?: string;
  purchase_intent_score?: number;
  purchase_intent_band?: string;
  purchase_intent_reason?: string;
};

type SEOAgentBridgeClickedPayload = SEOAgentBridgeViewedPayload & {
  target: string;
};

type SEOIntentCapturedPayload = {
  source_path: string;
  intent: string;
  page_category: string;
  target: string;
  placement?: string;
  topic_key?: string;
  chip_prompt?: boolean;
};

export function trackSEOAgentBridgeViewedLazy(payload: SEOAgentBridgeViewedPayload) {
  void import("@/lib/analytics-seo-bridge")
    .then(({ trackSEOAgentBridgeViewed }) => trackSEOAgentBridgeViewed(payload))
    .catch(() => {});
}

export function trackSEOAgentBridgeClickedLazy(payload: SEOAgentBridgeClickedPayload) {
  void import("@/lib/analytics-seo-bridge")
    .then(({ trackSEOAgentBridgeClicked }) => trackSEOAgentBridgeClicked(payload))
    .catch(() => {});
}

export function trackSEOIntentCapturedLazy(payload: SEOIntentCapturedPayload) {
  void import("@/lib/analytics-seo-bridge")
    .then(({ trackSEOIntentCaptured }) => trackSEOIntentCaptured(payload))
    .catch(() => {});
}
